import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelXS } from '@sorare/core/src/atoms/typography';
import { TextureBackground } from '@sorare/core/src/atoms/ui/TextureBackground';
import { ensureHexColor } from '@sorare/core/src/lib/colors';

import type { TeamSlot_anyTeam } from './__generated__/index.graphql';

const Wrapper = styled(Vertical)`
  width: 100%;
  height: 100%;
  border-radius: var(--unit);
  position: relative;
  border: 1px solid var(--c-nd-50);
  padding: var(--half-unit);
  object-fit: contain;
  isolation: isolate;
  overflow: hidden;
`;

const TeamLogo = styled.img`
  width: 32px;
  object-fit: contain;
`;

const ShortName = styled(LabelXS)`
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  text-align: center;
`;

const StyledTextureBackground = styled(TextureBackground)`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
`;

type Props = {
  anyTeam?: TeamSlot_anyTeam | null;
};

export const TeamSlot = ({ anyTeam }: Props) => {
  const { pictureUrl, shortName, styleGuideColor } = anyTeam || {};
  const color = ensureHexColor(styleGuideColor);
  return (
    <Wrapper center>
      <StyledTextureBackground
        background="missions"
        color={['#000000', color]}
        imageOpacity={0.9}
      />
      <TeamLogo src={pictureUrl || undefined} alt="" />
      <ShortName bold className="text-center">
        {shortName}
      </ShortName>
    </Wrapper>
  );
};

TeamSlot.fragments = {
  anyTeam: gql`
    fragment TeamSlot_anyTeam on TeamInterface {
      slug
      shortName
      pictureUrl(derivative: "avatar")
      styleGuideColor
    }
  ` as TypedDocumentNode<TeamSlot_anyTeam>,
};
